module.exports = __webpack_public_path__ + "img/2bench.2c2226ef.svg";